import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PermissionService } from '@core/services/permission.service';
import { PermissionStore } from '@core/store/permission.store';
import { of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Injectable()
export class RoutePermissionResolver  {
  constructor(private permissionStore: PermissionStore, private permissionService: PermissionService) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    // Simple solution: Return immediately to allow navigation, load permissions in background
    // This prevents blocking navigation while permissions load
    this.permissionService.getPagePermission(route.data).pipe(
      tap(res => {
        if (res && res['data']) {
          this.permissionStore.setStore(res['data']);
        }
      }),
      catchError(_error => {
        return of([]);
      })
    ).subscribe();

    this.permissionService.getPageLookupPermission().pipe(
      tap(res => {
        if (res && res['data']) {
          this.permissionStore.setStore(res['data'], 'LP');
        }
      }),
      catchError(_error => {
        return of([]);
      })
    ).subscribe();

    // Return immediately - don't wait for API calls
    return of([[], []]);
  }
}
